import { render, staticRenderFns } from "./BankInfoForm.vue?vue&type=template&id=bfa63c6a"
import script from "./BankInfoForm.vue?vue&type=script&lang=js"
export * from "./BankInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports